var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useEffect } from 'react';
var LAYOUT_BREAKPOINT = 600;
// Return type of the layout based on component width
function useInternalLayout(targetRef) {
    var _a = __read(useState('horizontal'), 2), layout = _a[0], setLayout = _a[1];
    useEffect(function () {
        var element = targetRef.current;
        function setLayoutType() {
            if (element) {
                setLayout(element.clientWidth < LAYOUT_BREAKPOINT ? 'vertical' : 'horizontal');
            }
        }
        setLayoutType();
        window.addEventListener('resize', setLayoutType);
        return function () {
            window.removeEventListener('resize', setLayoutType);
        };
    }, [targetRef]);
    return layout;
}
export default useInternalLayout;
